// extracted by mini-css-extract-plugin
module.exports = {"cardDashboardgeneral":"identificacion_cardDashboardgeneral__1YdqV"};